module.exports = __webpack_public_path__ + "img/pokal.8e09b603.png";